import React from "react";
import type {GridFilterInputValueProps} from '@mui/x-data-grid';

export const EmptyInputComponent: React.FC<GridFilterInputValueProps> = () => {
    // Don't show anything
    return <></>;
}
